import { RowType } from "../types/RowType";
import ExtractedCell, { ExtractedCellData } from "./ExtractedCell";

export { ExtractedRow, ExtractedRowData };

type ExtractedRowData = {
  rowType: RowType;
  rowNumber: number;
  pageRowNumber: number;
  pageId: string;
  cells: ExtractedCellData[];
};
class ExtractedRow {
  rowType: RowType;
  rowNumber: number;
  pageRowNumber: number;
  pageId: string;
  cells: ExtractedCell[];

  constructor(data: ExtractedRowData) {
    this.rowType = data.rowType;
    this.rowNumber = data.rowNumber;
    this.pageRowNumber = data.pageRowNumber;
    this.pageId = data.pageId;
    this.cells = data.cells.map((cell) => new ExtractedCell(cell));
  }

  static createTest(rest: Partial<ExtractedRowData> = {}): ExtractedRow {
    const data: ExtractedRowData = {
      cells: [],
      rowNumber: 0,
      pageRowNumber: 0,
      pageId: "PG0",
      rowType: "IGNORE",
    };

    return new ExtractedRow({
      ...data,
      ...rest,
    });
  }

  toData(): ExtractedRowData {
    return {
      rowType: this.rowType,
      rowNumber: this.rowNumber,
      pageRowNumber: this.pageRowNumber,
      pageId: this.pageId,
      cells: this.cells,
    };
  }
}
